export enum Status {
  PROCESSING = 'processing',
  FAILED = 'failed',
  SUCCEEDED = 'succeeded',
  HIDDEN = 'hidden',
  DONE = 'done',
  NOT_DONE = 'notDone',
  PENDING = 'pending',
}

export type StatusProcessing = 'processing';
export type StatusFailed = 'failed';
export type StatusSucceeded = 'succeeded';
export type StatusHidden = 'hidden';
export type StatusDone = 'done';
export type StatusNotDone = 'notDone';
export type StatusPending = 'pending';
